import { Client, Account, Databases, Storage as AppwriteStorage } from 'appwrite';

const client = new Client();

client
    .setEndpoint('https://sfo.cloud.appwrite.io/v1')
    .setProject('692935090021bcab8d1f'); // Your Project ID

export const account = new Account(client);
export const databases = new Databases(client);
export const storage = new AppwriteStorage(client); // Use the alias here
export { client };